(function Fullscreen($, Adzuki)
{
	"use strict";
	
	var Fullscreen = {};

	Fullscreen.toggleFullscreen = function _toggleFullscreen(elem)
	{
		if (Fullscreen.isFullscreen()) {
			document.exitFullscreen();

			return;
		}

		elem.requestFullscreen().catch(function _onError(error) {
			throw new Error('Error setting element to fullscreen: ' + error.message);
		});
	};

	Fullscreen.isFullscreen = function _isFullscreen()
	{
		var is_fullscreen = false;

		if (
			(document.fullscreenElement !== undefined && document.fullscreenElement !== null) ||
			(document.webkitFullscreenElement !== undefined && document.webkitFullscreenElement !== null) ||
			(document.mozFullScreenElement !== undefined && document.mozFullScreenElement !== null) ||
			(document.msFullscreenElement !== undefined && document.msFullscreenElement !== null)
		) {
			is_fullscreen = true;
		}

		return is_fullscreen;
	};

	Fullscreen.isSupported = function _isSupported()
	{
		var supported = false;

		if (
			document.fullscreenEnabled ||
			document.webkitSupportsFullscreen ||
			document.webkitFullscreenEnabled ||
			document.mozFullScreenEnabled ||
			document.msFullscreenEnabled
		) {
			supported = true;
		}

		return supported;
	};

	Adzuki.Fullscreen = Fullscreen;

}(jQuery, window.Adzuki || {}));
